// Toast notifications; also relays core "toast" bus events.

import { bus } from "../core/bus";
import { $ } from "./dom";

let toastT: ReturnType<typeof setTimeout> | undefined;

export function toast(msg: string): void {
  const t = $("#toast");
  t.textContent = msg;
  t.classList.add("show");
  clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove("show"), 2200);
}

bus.on("toast", ({ msg }) => toast(msg));
